<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>看广告统计</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button type="success" size="mini" :loading="loading" icon="el-icon-search" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >

      <el-table-column
        prop="date"
        label="日期"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.date }}</span>
          <span v-else>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ad_price"
        label="广告收入"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.ad_price }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="count"
        label="观看广告数"
        align="center"
      />
      <el-table-column
        prop="user"
        label="观看人数"
        align="center"
      />
      <el-table-column
        prop="user_avg"
        label="人均次数"
        align="center"
      />
      <el-table-column
        prop="spins"
        label="发放体力"
        align="center"
      />
      <el-table-column
        prop="spin_avg"
        label="人均发放"
        align="center"
      />
      <el-table-column
        prop="rate"
        label="渗透率"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="320"
            trigger="hover"
            content="渗透率=看广告人数/DAU"
          >
            <span slot="reference">渗透率 <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template scope="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.rate }}%</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="arpu"
        label="广告ARPU"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="320"
            trigger="hover"
            content="广告ARPU=广告收入/DAU"
          >
            <span slot="reference">广告ARPU <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template scope="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.arpu }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="arrpu"
        label="广告变现ARPPU"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="320"
            trigger="hover"
            content="广告变现ARPPU=广告收入/看广告的人数"
          >
            <span slot="reference">广告变现ARPPU <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template scope="scope">
          <span v-if="scope.row.type === 1">{{ scope.row.arppu }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

    </el-table>

    <totalStat ref="ad" />
  </el-card>
</template>

<script>
import { getAdViewStat } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import totalStat from '@/views/config/ad-view-stat/components/echart.vue'

export default {
  name: 'AdViewStat',
  components: {
    totalStat
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        level: 1
      },
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.level = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getAdViewStat(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        this.tableData = res.data.data
        this.$refs.ad.refresh(this.tableData)
      })
    },
    exportData() {
      this.queryParams.level = 1
      getAdViewStat(this.queryParams).then(res => {
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
